import { Link } from 'react-router-dom';
import { initials } from '../api/coach-teams.js';
import type { MyTeamPillRow } from '../api/my-teams.js';

/**
 * "My Team: <name>" with the team's logo (mockup *Teams*, boards 5 and 8,
 * approved 25 October), one per team, opening My Team. From a child's page it
 * carries the child, so My Team's ‹ goes back there. `lead` says whose, on a
 * parent's or coach's Home (board 11): a child's name or the coach's role.
 */
export function TeamPill({ team, child = null, lead = 'My Team' }: { team: MyTeamPillRow; child?: string | null; lead?: string }) {
  return (
    <Link className="team-pill" to={`/teams/${team.team_id}${child ? `?child=${child}` : ''}`}>
      {team.logo_url ? (
        <img className="team-pill-logo" src={team.logo_url} alt="" />
      ) : (
        <span className="team-pill-logo" aria-hidden="true">
          {initials(team.name)}
        </span>
      )}
      <span className="team-pill-name">
        <span className="team-pill-lead">{lead}:</span> {team.name}
      </span>
      <span className="chevron" aria-hidden="true">
        ›
      </span>
    </Link>
  );
}
